import React, { createContext, useState } from 'react';

export const SignupContext = createContext();

export const SignupProvider = ({ children }) => {
    const [APIformData, setAPIFormData] = useState({});
    const [userName, setUserName] = useState("Guest");
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [userId, setUserId] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <SignupContext.Provider
            value={{
                APIformData,
                setAPIFormData,
                userName,
                setUserName,
                otp,
                setOtp,
                isOtpSent,
                setIsOtpSent,
                userId,
                setUserId,
                isLoggedIn,
                setIsLoggedIn,
            }}
        >
            {children}
        </SignupContext.Provider>
    );
};
